var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("iframe", {
      staticStyle: { display: "none" },
      attrs: {
        id: "upload-sink-" + _vm.fileuploadid,
        name: "upload-sink-" + _vm.fileuploadid,
        src: "",
      },
    }),
    _vm._v(" "),
    _c(
      "form",
      {
        staticClass: "upload",
        attrs: {
          id: _vm.fileuploadid,
          method: "post",
          action: "",
          enctype: "multipart/form-data",
          novalidate: "",
          target: "upload-sink-" + _vm.fileuploadid,
        },
      },
      [
        _c("input", {
          ref: "uploadfiles",
          staticClass: "upload__file sr-only",
          attrs: {
            "aria-hidden": "true",
            type: "file",
            accept: _vm.fileExtensions,
            name: "files",
            id: "fileupload" + _vm.fileuploadid,
            "data-multiple-caption": "{count} files selected",
            multiple: _vm.multiple,
          },
          on: {
            change: function ($event) {
              return _vm.$emit("fileschanged")
            },
          },
        }),
        _vm._v(" "),
        _c("input", { attrs: { type: "hidden", name: "ajax", value: "1" } }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "d-flex flex-column flex-center text-center",
            class: { "pt-3": !_vm.inline, "w-100": _vm.expanded },
          },
          [
            _c("input", {
              staticClass: "btn btn--dark label-aligned m-auto",
              class: { "w-100": _vm.expanded, "w-auto@large": !_vm.expanded },
              attrs: {
                type: "button",
                disabled: _vm.uploadInProgress,
                value: _vm.text,
              },
              on: { click: _vm.pickFile },
            }),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }